<app-main-navbar></app-main-navbar>

<div class="container-fluid" style="background-color: #F0F2F7;color:black">
  <div class="row  align-items-start" style="background-color: #F0F2F7;">
    <div class="col mt-5">
      <p style="font-weight: normal; font-size: 20px;margin-bottom:10px;">
        Find the company you are looking for by entering the legal company name, ISIN or website URL and select the company type.
      </p>

      <form class="row search-form" [formGroup]="companySearchForm" >
        <div class="col-auto">
          <label class="visually-hidden">Company Name</label>
          <input type="text" class="form-control" data-cy="company-name" id="name" placeholder="Company Name (Legal)"
            formControlName="name">
        </div>
        or
        <div class="col-auto">
          <label class="visually-hidden">ISIN</label>
          <input type="text" class="form-control" data-cy="company-isin" id="isin" placeholder="ISIN"
            formControlName="isin">
        </div>
        or
        <div class="col-auto">
          <label for="url" class="visually-hidden">URL</label>
          <input type="text" class="form-control" data-cy="company-url" id="url" placeholder="URL"
            formControlName="url">
        </div>
      and 
        <div class="col-auto">
          <div class="dropdown" >
              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                data-bs-toggle="dropdown" aria-expanded="false">
                {{companySearchForm.value.companytype}}
              </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <button class="dropdown-item" (click)="onSearchTypeChange('Public Company')">Public Company</button>
              </li>
              <li>
                <button class="dropdown-item" (click)="onSearchTypeChange('Private Company')">Private Company</button>
              </li>
              <li>
                <button class="dropdown-item" (click)="onSearchTypeChange('All')">All</button>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-auto" *ngIf="showSpinner">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="col-auto">
          <button class="btn search-button" (click)="companySearch()"
            [disabled]="!companySearchForm.value.name && !companySearchForm.value.url &&!companySearchForm.value.isin"
            data-cy="company-search-button">Search</button>
        </div>
        
      </form>

      <!-- search results -->
      <div class="card" *ngIf="companies.length>0">
        <table class="table table-condensed table-hover">
          <thead>
            <tr>

              <th scope="col">Name</th>
              <!-- NAME-WIDER;TICKER.SHORT -->
              <!-- <th scope="col">Ticker</th>
              <th scope="col">ISIN</th> -->
              <th scope="col">Country</th>
              <th scope="col">Region</th>
              <!-- <th scope="col">Type</th> -->
              <th scope="col">GICS Sub-Industry<i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'Quant IP classifies private companies into the closest GICS industry via patent similarity; public companies keep their GICS Sub-industry.'"
                  matTooltipPosition="above">
                </i> </th>

              <th scope="col">
                Inventions (all time)
              </th>


              <!-- <th scope="col">URL</th> -->


              <th scope="col">Identifiers</th>
              <!-- <th scope="col">Capital IQ Company ID</th> -->


              <th scope="col">Action</th>
              <th scope="col" *ngIf="roles!.includes('Report') ">Report (V1)

                <div class="spinner-border text-primary" role="status" *ngIf="reportDownloadingV1">
                  <span class="visually-hidden">Loading...</span>
                </div>


              </th>
              <th scope="col" *ngIf="roles!.includes('ReportV2') ">Report (V2)

                <div class="spinner-border text-primary" role="status" *ngIf="reportDownloadingV2">
                  <span class="visually-hidden">Loading...</span>
                </div>

              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let company of companies  | paginate: {id:'pag_company_search', itemsPerPage: 10, currentPage: paginator_1_page }">

              <td>
                <div class="text" style="max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                " matTooltip="{{company.entity_name}}">
                  {{ company.entity_name }}
                </div>
                <div class="isin" style="font-size: 16px;color: cadetblue;">
                  {{company.isin}} <a
                    [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                    target="_blank">
                    <i class="bi bi-box-arrow-up-right" style="font-size: 14px;"></i>
                  </a>
                </div>
              </td>
              <!-- <td>{{company.tickersymbol}}</td>
              <td>{{company.isin}}</td> -->

              <td>{{company.country}}</td>
              <td>{{company.region}}</td>
              <!-- <td>{{company.companytype}}</td> -->
              <td>
                <span *ngIf="company.gsubind_extended_name">{{company.gsubind_extended_name}}</span>
                <span *ngIf="!company.gsubind_extended_name && company.subindustryname">{{company.subindustryname}}</span>
              </td>
              <!-- <td *ngIf="company.subindustryname">{{company.subindustryname}}</td> -->

              <td>{{company.n_inventions}}</td>

              <!-- <td>
                <a [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                  target="_blank">
                  {{ company.webpage || 'No webpage available' }}
                </a>
              </td> -->
              <!-- <td>{{company.entityid}}</td> -->
              <td>
                QIP <i class="bi bi-copy" style="margin-right: 20px;color:#9681D1" matTooltip="Copy Quant IP Entity ID"
                  [cdkCopyToClipboard]="company.entityid"></i> S&P
                <i class="bi bi-copy" style="margin-right: 20px;color:black" matTooltip="Copy Capital IQ Company ID"
                  [cdkCopyToClipboard]="company.companyid?.toString() || ''"></i>

              </td>
              <!-- <td>{{company.companyid}}</td> -->

              <td>
                <button class="btn search-button" (click)="addCompany(company)"
                  [disabled]="!company.gsubind_extended && !company.gsubind" data-cy="select-company-button">
                  View
                </button>
              </td>
              <td *ngIf="roles!.includes('Report') ">
                <button class="btn download-button" (click)="downloadreportv1(company)"
                  [disabled]="reportDownloadingV2||reportDownloadingV1" data-cy="report-v1-button">
                  <i class="bi bi-file-earmark-arrow-down"></i> </button>

              </td>
              <td *ngIf="roles!.includes('ReportV2') ">
                <button class="btn download-button" (click)="downloadreportv2(company)"
                  [disabled]="!company.subindustryname||reportDownloadingV2||reportDownloadingV1"
                  data-cy="report-v2-button">
                  <i class="bi bi-file-earmark-arrow-down"></i> </button>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination-controls id="pag_company_search" [maxSize]="5" (pageChange)="paginator_1_page = $event"
          style="align-items: flex-start;">
        </pagination-controls>

      </div>
      <!-- slected companies -->
      <br><br>
      <!-- <span class="mt-4" *ngIf="selected_companies.length>0" styles="font-size:14px"> <strong>
          Selected Companies
        </strong>

      </span>
      <div class="card mt-2" *ngIf="selected_companies.length>0">

        <table class="table table-condensed table-hover">
          <thead>
            <tr>

              <th scope="col">Name</th>

              <th scope="col">Country</th>
              <th scope="col">Region</th>
              <th scope="col">Type</th>
              <th scope="col">No. of Inventions</th>


              <th scope="col">URL</th>
              <th scope="col">ISIN</th>
              <th scope="col">Ticker</th>
              <th scope="col">Entity ID</th>
              <th scope="col">Company ID</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let company of selected_companies  | paginate: {id:'pag_2' ,itemsPerPage: 3, currentPage: paginator_2_page }">

              <td>{{company.entity_name}}</td>

              <td>{{company.country}}</td>
              <td>{{company.region}}</td>

              <td>{{company.companytype}}</td>
              <td>{{company.n_inventions}}</td>

              <td>{{company.webpage}}</td>

              <td>{{company.isin}}</td>
              <td>{{company.tickersymbol}}</td>
              <td>{{company.entityid}}</td>
              <td>{{company.companyid}}</td>
              <td><i class="bi bi-trash" (click)="removeCompany(company)"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination-controls id="pag_2" [maxSize]="2" (pageChange)="paginator_2_page = $event"
          style="align-items: flex-start;">
        </pagination-controls>



      </div>
      <div class="submit_button mt-4" *ngIf="selected_companies.length>0">
        <button type="button" class="btn " data-cy="company-select-button" style="background-color:#9681d1"
          (click)="submitCompanies()">
          Submit
        </button>
      </div> -->


    </div>


  </div>


</div>